<template>
  <div class="modal-overlay">
    <div
      class="mmodal-content subscription-blocker-content"
      style="width: 80vw; min-height: 80vh"
    >
      <div class="modal-body subscription-message-body">
        <div class="blocker-header">
          <h1>🚫 System Access Revoked 🚫</h1>
        </div>
        <div class="blocker-details">
          <p>
            Your **subscription has expired** or is currently **inactive**. To
            restore full system access, please contact our support team or make
            the required payment.
          </p>

          <div class="contact-info">
            <h2>📞 Support Contact</h2>
            <div style="max-width: 300px">
              <div class="info-detail">
                <label>Phone:</label>
                <span>+254 741 627 680 </span>
              </div>
              <div class="info-detail">
                <label>Email:</label>
                <span>info@aezoradynamics.top</span>
              </div>
            </div>
          </div>

          <div class="payment-info">
            <h2>💰 Make Payment</h2>
            <p>
              You can reactivate your account instantly by channeling your
              subscription fee through M-Pesa:
            </p>
            <div style="max-width: 300px">
              <div class="info-detail">
                <label>M-Pesa Paybill Number:</label>
                <span class="highlight">522522</span>
              </div>
              <div class="info-detail">
                <label>Account Number:</label>
                <span class="highlight">1313480363</span>
              </div>
            </div>

            <p class="note">
              **Note:** System Will be Unlocked once the payment is confirmed**
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubscriptionBlocker", // Renamed for clarity
  props: {
    // You might want to pass user details for a personalized message
    user_id: {
      type: String,
      required: false,
    },
  },
  methods: {
    // These methods can be used to close the modal if an action is allowed
    closeModal() {
      this.$emit("close-blocker");
    },
    // saveModal() {
    //   this.$emit("save");
    // },
  },

  mounted() {
    // Log the user ID if passed
    console.log("Subscription Blocker displayed for user:", this.user_id);
  },
};
</script>

<style scoped>
/* Resetting the modal body for the new content */
.modal-body {
  padding: 2rem;
  overflow-y: auto;
  flex-grow: 1;
  text-align: center; /* Center main content */
}

/* Specific styles for the blocker message */
.subscription-blocker-content {
  border: 4px solid #f0ad4e; /* Warning border color */
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.blocker-header h1 {
  color: #d9534f; /* Danger red color */
  margin-bottom: 1.5rem;
  font-size: 1.8rem;
}

.blocker-details {
  text-align: left;
  line-height: 1.6;
}

.blocker-details p {
  margin-bottom: 1rem;
}

.contact-info,
.payment-info {
  margin-top: 2rem;
  padding: 1rem;
  border-radius: 4px;
  background-color: #f9f9f9;
}

.contact-info h2,
.payment-info h2 {
  color: #337ab7; /* Info blue color */
  border-bottom: 2px solid #eee;
  padding-bottom: 0.5rem;
  margin-top: 0;
  margin-bottom: 1rem;
}

.info-detail {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
}

.info-detail label {
  font-weight: bold;
  color: #555;
  margin-right: 1rem;
}

.highlight {
  color: #5cb85c; /* Success green color for key payment details */
  font-weight: bold;
}

.note {
  font-size: 0.9rem;
  color: #777;
  margin-top: 1rem;
  border-top: 1px dashed #ddd;
  padding-top: 0.5rem;
}

/* Keeping necessary structural styles */
.modal-overlay {
  /* ... existing overlay styles */
}

/* Removed: .patient-profile, .profile-header, .profile-details, .detail, .close */
</style>
